import { render, staticRenderFns } from "./MySpacePriorityTasksWidget.vue?vue&type=template&id=599c0e4b&scoped=true&"
import script from "./MySpacePriorityTasksWidget.vue?vue&type=script&lang=js&"
export * from "./MySpacePriorityTasksWidget.vue?vue&type=script&lang=js&"
import style0 from "./MySpacePriorityTasksWidget.vue?vue&type=style&index=0&id=599c0e4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599c0e4b",
  null
  
)

export default component.exports